import { BASEURL } from "../../API/apiData";
import {bmcListsRoutes, bmcMainRoutes} from "./routes"

const getAllValueProportions = async (projectID , bmcID) => {
  const token = localStorage.getItem("token");

    const requestOptions = {
        method: "GET",
        headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
        },
    };
    const response = await fetch(
        `${BASEURL}projects/${projectID}/business_model_canvas/${bmcID}/${bmcMainRoutes.propositions}`,
        requestOptions
      );
      const results = await response.json();
      return results;
}

const createNewValueProportions = async (projectID, projectName, bmcID) => {
  const token = localStorage.getItem("token");

    const data = {
      "value_proposition": {
        value_proposition_name: `${projectName} Value propositions`
      }
    }
    const requestOptions = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(data),
      };
    const response = await fetch(
    `${BASEURL}projects/${projectID}/business_model_canvas/${bmcID}/${bmcMainRoutes.propositions}`,
    requestOptions
    );
    const results = await response.json();
    return results;
} 

// === LIST ITEMS ===
const createNewValueProportionsList = async (projectID, bmcID, channelID, name ) => {
  const token = localStorage.getItem("token");

  const data = {
    value_proposition_item: {
      item_name: name
    }
  }

  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
       Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(data),
  };

  const response = await fetch(
    `${BASEURL}projects/${projectID}/business_model_canvas/${bmcID}/${bmcMainRoutes.propositions}/${channelID}/${bmcListsRoutes.propositionsItems}`,
    requestOptions
    );

const results = await response.json();
return results;

}

const editNewValueProportionsList = async (projectID, bmcID, channelID, name, ID ) => {
  const token = localStorage.getItem("token");

const data = {
  value_proposition_item: {
    item_name: name
  }
}

const requestOptions = {
  method: "PUT",
  headers: {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  },
  body: JSON.stringify(data),
};

const response = await fetch(
  `${BASEURL}projects/${projectID}/business_model_canvas/${bmcID}/${bmcMainRoutes.propositions}/${channelID}/${bmcListsRoutes.propositionsItems}/${ID}`,
  requestOptions
  );

const results = await response.json();
return results;

}

export { getAllValueProportions , createNewValueProportions, createNewValueProportionsList, editNewValueProportionsList }